import { useNavigate } from 'react-router-dom';
import { Avatar, Badge, Button } from '../../../components/ui';
import { activeFilter } from '../../../components/common/ListPage/listFilters';
import { Cell, ListPage } from '../../../components/common/ListPage/ListPage';

export default function VendorList() {
  const navigate = useNavigate();
  const add = <Button leftIcon="plus" onClick={() => navigate('/vendors/new')}>Add supplier</Button>;
  return (
    <ListPage
      title="Suppliers"
      path="/vendors"
      filters={[activeFilter]}
      searchPlaceholder="Name, phone, code"
      actions={add}
      rowTo={(v) => `/vendors/${v._id}`}
      rowActions={(v) => [
        { label: 'View', icon: 'eye', onClick: () => navigate(`/vendors/${v._id}`) },
        { label: 'Edit', icon: 'edit', onClick: () => navigate(`/vendors/${v._id}/edit`) },
        { label: 'New purchase', icon: 'cart', onClick: () => navigate(`/purchases/new?vendorId=${v._id}`) },
        { label: 'Pay a bill', icon: 'rupee', onClick: () => navigate(`/transactions/new?category=purchase_payment&vendorId=${v._id}`) },
      ]}
      columns={[
        {
          header: 'Supplier', sort: 'name',
          render: (v) => (
            <span className="flex items-center gap-3">
              <Avatar name={v.name} size={32} />
              <Cell title={v.name} sub={v.vendorCode} mono />
            </span>
          ),
          csv: (v) => v.name,
        },
        { header: 'Contact person', sort: 'contactPerson', render: (v) => v.contactPerson || <span className="text-ink-300">-</span>, csv: (v) => v.contactPerson },
        { header: 'Phone', sort: 'phone', render: (v) => <span className="tabular">{v.phone || '-'}</span>, csv: (v) => v.phone },
        { header: 'City', sort: 'address.city', render: (v) => v.address?.city || <span className="text-ink-300">-</span>, csv: (v) => v.address?.city },
        { header: 'GSTIN', sort: 'gstin', render: (v) => <span className="font-mono text-xs">{v.gstin || '-'}</span>, csv: (v) => v.gstin },
        { header: 'Status', sort: 'isActive', render: (v) => (v.isActive ? <Badge tone="green" dot>Active</Badge> : <Badge tone="grey" dot>Inactive</Badge>), csv: (v) => (v.isActive ? 'Active' : 'Inactive') },
      ]}
      mobile={(v) => ({ title: v.name, subtitle: [v.phone, v.address?.city].filter(Boolean).join(', ') || v.vendorCode })}
      empty={{ icon: 'truck', title: 'No suppliers yet', message: 'Add the shops and dealers you buy material from.', action: add }}
    />
  );
}
